<!-- buddy Slide -->
<script setup lang="ts">
import monsterUrl from '/assets/monster/glad.png';
import SpeechBubble from '@/components/SpeechBubble.vue';

const props = defineProps<{
  text: string;
  color: 'yellow' | 'blue' | 'green' | 'purple';
}>();
</script>

<template>
  <div class="relative flex justify-start ">
    
      <!-- Speech bubble -->
      <!-- <div class="w-full mb-4  md:w-1/2 md:order-2 md:mb-0 md:pl-4">
        <speech-bubble :color="color" class="w-full max-w-[600px]">
          <div
      
            class="flex items-center justify-center h-full p-4 -mt-4 text-base text-center md:text-lg"
          > </div>
        </speech-bubble>
      </div> -->

      <div class="flex justify-center flex-col items-center relative mx-auto">
        <div class="relative flex justify-center items-center">
          <speech-bubble
            :color="color"
            class="w-[200px] md:w-[220px]"
          />

          <div
            class="absolute lg:text-[15px] text-[min(5vw,1.15rem)] text-center w-[70%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            v-html="text"
          >
          </div>
        </div>
        <img class="monster shrink-0 -mt-4" :src="monsterUrl" />
      </div>
     
      
      <!-- Monster image -->
      <!-- <div class="w-48 md:w-1/2 md:order-1">
        <img class="mx-auto " :src="monsterUrl" alt="Monster" />
      </div> -->
 
  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  /* Additional mobile-specific styles if needed */
}
</style>